export enum RequestsListMode {
  ALL = 'all',
  OPEN = 'open',
  IN_PROGRESS = 'inprogress'
}
